import { useState } from "react";
import { useSnackbar } from 'notistack';
import { Paper, Grid,  } from "@mui/material";
import { getEngineSummaryReportApi } from "../apiService";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import Header from "./Header";
import LessorFilter from "./LessorFilter";
import { trackActivity } from "../../../utils/mixpanel";

const EngineCustomTechnicalReport = ({pltConstants,dropDownLoader}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({});
  const onFieldChange = (key, value) => { setReportData({ ...reportData, [key]: value }) }
  const onExportReport = (extention,) => {
    const query = {
      file_type: extention, 
      ...(reportData?.lessor_name_id?.length > 0) && { lessor_name_id: reportData?.lessor_name_id?.map(item => item.id).join(",") ?? "" },
    };
    setLoading(true)
    globalGetService(getEngineSummaryReportApi(query))
      .then(response => {
        setLoading(false)
        if (checkApiStatus(response)) {
          setReportData({})
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Engine Custom Report - Technical`, success_msg: response?.data?.message, payload: query, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Engine Custom Report - Technical`, error_msg: response?.data?.message, payload: query, response: response?.data })
        }
      });
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container spacing={{ xs: 5, md: 1 }} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 8 }}>
              <Header title="Engine Custom Report - Technical" description="The Engine Summary Report provides a concise overview of all the engines in the fleet along with basic information, fitment location and utilization data." />
            </Grid>
            <Grid size={{ md: 2, xs: 4 }} sx={{ display: "flex", justifyContent: "flex-end" ,alignItems: "flex-start" }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
          <Grid size={{ md: 12, xs: 12 }}>
          <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange}/>
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default EngineCustomTechnicalReport